import { Component, Input } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary';
export type ButtonTone = 'default' | 'neutral' | 'success' | 'critical' | 'dark';
export type ButtonSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'fi-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false,
})
export class ButtonComponent {
  @Input() variant: ButtonVariant = 'primary';
  @Input() tone: ButtonTone = 'default';
  @Input() size: ButtonSize = 'md';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() iconBefore?: string;
  @Input() iconAfter?: string;
  @Input() disabled = false;
  @Input() loading = false;

  /**
   * Hides the label visually while keeping it in the accessibility tree, and
   * squares the control — the reference's Button--iconOnly. The label is still
   * required: elements/button/button.twig keeps it in
   * `<span class="Button-label u-hiddenVisually">` rather than using aria-label.
   */
  @Input() iconOnly = false;

  /** When set the control renders as an anchor, as the reference does. */
  @Input() url?: string;
  @Input() target?: string;

  get isDisabled(): boolean {
    return this.disabled || this.loading;
  }

  get hostClasses(): string {
    const classes = [
      'fi-button',
      `fi-button--${ this.variant }`,
      `fi-button--${ this.tone }`,
      `fi-button--${ this.size }`,
    ];

    if ( this.loading ) {
      classes.push('fi-button--loading');
    }

    if ( this.iconOnly ) {
      classes.push('fi-button--icon-only');
    }

    return classes.join(' ');
  }
}
